export default function EntityAssociationsTableHeader() {
  return (
    <div className="border-1 border-gray flex border-b px-0 py-2 text-left">
      <div className="block w-[28%] font-bold">
        <h2 className="text-sm">Name</h2>
      </div>
      <div className="block w-[18%] font-bold">
        <h2 className="text-sm text-center">Entity ID</h2>
      </div>
      <div className="block w-[24%] font-bold">
        <h2 className="text-sm text-center">Entity Type</h2>
      </div>
      <div className="block w-[18%] font-bold">
        <h2 className="text-sm text-center">EIN Number</h2>
      </div>
      <div className="block w-[12%] font-bold">
        <h2 className="text-sm text-center">Location Count</h2>
      </div>
    </div>
  );
}
